import React from 'react'
import './skills.scss'
export const Skills = () => {
  return (
    <section class="skills" id="skills">
      <div class="max-width">
        <h2 class="title">My skills</h2>
        <div class="skills-content">
          <div class="column left">
            <div class="text">My creative skills & experiences.</div>
            <p>Full stack developer capable of handling both frontend and backend applications in MERN stack. I have developed some realtime apps both as hobby and product and it is currently in live. I work closely with designers and develop pixel perfect product. I develop code in optimised way such that the render cycle is minimum in the application loading the website faster.</p>
            {/* <a href="#">Read more</a> */}
          </div>
          <div class="column right">
            <div class="bars">
              <div class="info">
                <span>React js</span>
                <span>80%</span>
              </div>
              <div class="line react"></div>
            </div>
            <div class="bars">
              <div class="info">
                <span>Node js</span>
                <span>75%</span>
              </div>
              <div class="line node"></div>
            </div>
            <div class="bars">
              <div class="info">
                <span>Javascript</span>
                <span>85%</span>
              </div>
              <div class="line js"></div>
            </div>
            <div class="bars">
              <div class="info">
                <span>HTML</span>
                <span>75%</span>
              </div>
              <div class="line html"></div>
            </div>
            <div class="bars">
              <div class="info">
                <span>CSS</span>
                <span>80%</span>
              </div>
              <div class="line css"></div>
            </div>
            <div class="bars">
              <div class="info">
                <span>Mongo DB</span>
                <span>70%</span>
              </div>
              <div class="line mongo"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
